module.exports = __webpack_public_path__ + "static/media/biglogo.cf1126f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/biglogo.png
// module id = 732
// module chunks = 0